import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { OrderService, SalesStoreReportDto, StoreOutputDto, StorePayingService, StoreService } from 'src/generated_client';



@Component({
  selector: 'app-sales-report',
  templateUrl: './sales-report.component.html',
  styleUrls: ['./sales-report.component.css']
})
export class SalesReportComponent implements OnInit {

  salesReportsForm: FormGroup = this.fb.group({

    fechaD: [''],
    fechaH: [''],
    comercio: [''],
    estado: [''],
    liq: [''],
  })

  displayedColumns: string[] = ['idC', 'comercio', 'idP', 'fechaP', 'nombreCli', 'telCli', 'dirCli', 'envio', 'desc', 'total', 'estado', 'comision'];
  salesReports: SalesStoreReportDto[] = [];
  storeOptions: StoreOutputDto[] = [];


  dateTo: any;
  dateFrom: any;

  statusOptions = [
    { value: 0, viewValue: 'Nuevo' },
    { value: 1, viewValue: 'Aceptado' },
    { value: 2, viewValue: 'Rechazado' },
    //{ value: 3, viewValue: 'Asignado a cadete' },
    //{ value: 4, viewValue: 'Cancelado' },
    { value: 5, viewValue: 'Cadete confirmado' },
    { value: 6, viewValue: 'En Viaje' },
    { value: 7, viewValue: 'Finalizado' },
    //{ value: 8, viewValue: 'Devuelto' },
    { value: 9, viewValue: 'Todos' }
  ];

  liquidationOption = [
    { value: 0, viewValue: 'Todos' },
    { value: 1, viewValue: 'Pendiente' },
    { value: 2, viewValue: 'Liquidado' }
  ]

  constructor(
    private fb: FormBuilder,
    private orderService: OrderService,
    private storeService: StoreService,
    private storePayingService: StorePayingService
  ) { }


  ngOnInit(): void {
    this.storeService.apiStoreGetAllStoresGet().subscribe(x => {
      this.storeOptions = x;
    })
  }

  inputDateFrom(event: any) {
    this.dateFrom = event.value;
  }

  inputDateTo(event: any) {
    this.dateTo = event.value;
  }

  get totalRows(): number {
    return this.salesReports.length;
  }

  getTotalComision(): number {
    return this.salesReports.reduce((sum, current) => sum + Number(current.qtDiscount), 0)
  }

  getTotal(): number {
    return this.salesReports.reduce((sum, current) => sum + Number(current.qtTotal), 0)
  }

  previewReport(form: any) {
    let dateTo = moment(this.dateTo).endOf('day');
    this.orderService.apiOrderStoreReportsGet(form.comercio, this.dateFrom, dateTo.toDate(), form.estado, form.liq).subscribe(x => {
      this.salesReports = x;
    })
  }

  public exportPDF() {
    console.log("Falta implementar");
  }
}
